import { copies } from '@reveni-io/reveni-ui'

import { miscPreviewSections } from '../constants'

export const getMiscLabel = (fullKey, customCopies, lang) => {
  const customText = customCopies?.[lang]?.[fullKey]

  if (customText) return customText

  const defaultTexts = {
    [miscPreviewSections.variants]: copies[lang]?.texts?.variants,
    [miscPreviewSections.otherProducts]: copies[lang]?.texts?.otherProduct,
    [miscPreviewSections.outOfStock]: copies[lang]?.texts?.productNotAvailable,
  }

  return defaultTexts[fullKey] || ''
}
